import { useMatches, type UIMatch } from 'react-router-dom';

export interface PageHandleV2 {
	title: string;
	displayFilter?: boolean;
	displayTimeFilter?: boolean;
	displaySearchFilter?: boolean;
	actions?: Array<{} & { type: 'button' | 'round-button'; title?: string; path: string }>;
	actionsMenu?: React.FunctionComponent;
	toolbar?: React.FunctionComponent;
	isChild?: boolean;
	variant?: 'default' | 'transparent';
}

const defaultPageHandle: PageHandleV2 = {
	title: '',
	displayFilter: true,
	displayTimeFilter: false,
	displaySearchFilter: false,
	actions: [],
	actionsMenu: undefined,
	toolbar: undefined,
	isChild: false,
	variant: 'default',
};

export const usePageHandle = () => {
	const matches = useMatches() as UIMatch<unknown, PageHandleV2>[];
	const active = matches[matches.length - 1];

	return active.handle || defaultPageHandle;
};
